import React from "react";

interface ModalProps {
  show: boolean;
  title: string;
  onClose: () => void;
  children?: React.ReactNode;
  size?: "small" | "large"; // optional size prop
}

const Modal: React.FC<ModalProps> = ({
  show,
  title,
  onClose,
  children,
  size = "large", // default to large for backward compatibility
}) => {
  if (!show) return null;

  // Decide modal width/height based on size
  const dialogStyle =
    size === "small"
      ? { width: "35%", height: "auto", maxWidth: "400px", margin: "auto" }
      : { width: "60%", height: "30%", maxWidth: "none", margin: "auto" };

  return (
    <div
      className="modal fade show d-block"
      tabIndex={-1}
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered" style={dialogStyle}>
        <div className="modal-content" style={{ height: "100%" }}>
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div
            className="modal-body"
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <div style={{ flex: 1, overflowY: "auto" }}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
